import { useAppSelector } from 'app/hooks';
import { selectCoBrand } from 'services/marketing/marketingSelectors';
import {
  selectOfferGroupCode,
  selectOfferPlanCode,
} from 'services/offer/offerSelectors';
import { CO_BRAND_LOGOS, CO_BRAND_PLAN_CODE, type CoBrandCode } from './config';

/**
 * Co-brand logo asset name, or `null` to use the brand's own logo.
 *
 * Two triggers, matching identityWeb: the `?cobrand` code (query param wins), then plan
 * `finsec2ind` on a Choice/HWA/Rely group.
 */
function useCoBrandLogo(): string | null {
  const coBrand = useAppSelector(selectCoBrand);
  const planCode = useAppSelector(selectOfferPlanCode);
  const groupCode = useAppSelector(selectOfferGroupCode);

  const queryCode = coBrand?.trim().toLowerCase() ?? '';
  const planGroupCode =
    planCode === CO_BRAND_PLAN_CODE
      ? (groupCode?.trim().toLowerCase() ?? '')
      : '';
  const coBrandCode = queryCode || planGroupCode;

  return CO_BRAND_LOGOS[coBrandCode as CoBrandCode] ?? null;
}

export default useCoBrandLogo;
